// @flow
import React from 'react';
import { connect } from 'react-redux';

import PopupContainer from '../PopupContainer';
import CreateUsersTutorial from '../CreateUsersTutorial';
import CreateUsersDrag from '../CreateUsersDrag';
import CreateUsersConfirm from '../CreateUsersConfirm';

// import styles from './createUsersPopup.css';
import * as selectors from '../../reducers';


type CreateUsersPopupPropTypes = {
  createUsersStep: number
};

const CreateUsersPopup = ({
  createUsersStep = 1,
  ...props
}: CreateUsersPopupPropTypes) => {
  let Content;
  switch (createUsersStep) {
    case 2:
      Content = CreateUsersDrag;
      break;
    case 3:
      Content = CreateUsersConfirm;
      break;
    default:
      Content = CreateUsersTutorial;
      break;
  }

  return (
    <PopupContainer isRound {...props} size="big">
      <Content {...props} />
    </PopupContainer>
  );
};


export default connect(
  state => ({
    createUsersStep: selectors.getCurrentCreateUsersStep(state),
  }),
)(CreateUsersPopup);



// WEBPACK FOOTER //
// ./src/scripts/components/CreateUsersPopup/index.jsx